/** Swap icon: two mini UI previews (sidebar vs simple) + bidirectional arrows.
 *  Always the same glyph — reads as “toggle between these two layouts”. */
export function EmbedLayoutSwapIcon({ size = 26 }: { size?: number }) {
  const height = Math.round(size * (24 / 40));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 24"
      width={size}
      height={height}
      aria-hidden
      className="shrink-0"
    >
      {/* Top arrow — old (sidebar) → new (simple) */}
      <path
        d="M 7 2.5 C 14 0.5 26 0.5 33 2.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
      />
      <path
        d="M 30.5 1.2 L 33.5 2.6 L 30.5 4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Bottom arrow — new → old */}
      <path
        d="M 33 21.5 C 26 23.5 14 23.5 7 21.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
      />
      <path
        d="M 9.5 20.2 L 6.5 21.6 L 9.5 23"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Old UI — sidebar + content (left) */}
      <rect
        x="0.5"
        y="6.5"
        width="16"
        height="15"
        rx="2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <rect x="0.5" y="6.5" width="5" height="15" rx="2" fill="currentColor" opacity="0.55" />
      <line x1="1.8" y1="10" x2="4.2" y2="10" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" opacity="0.9" />
      <line x1="1.8" y1="12.5" x2="4.2" y2="12.5" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" opacity="0.7" />
      <line x1="1.8" y1="15" x2="4.2" y2="15" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" opacity="0.5" />
      <rect x="7.5" y="9.5" width="7.5" height="2" rx="0.6" fill="currentColor" opacity="0.35" />
      <rect x="7.5" y="13" width="7.5" height="2" rx="0.6" fill="currentColor" opacity="0.25" />
      <rect x="7.5" y="16.5" width="5.5" height="2" rx="0.6" fill="currentColor" opacity="0.2" />

      {/* New UI — top bar + full-width content (right) */}
      <rect
        x="23.5"
        y="6.5"
        width="16"
        height="15"
        rx="2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <rect x="23.5" y="6.5" width="16" height="3.5" rx="2" fill="currentColor" opacity="0.35" />
      <line x1="25" y1="8.2" x2="28" y2="8.2" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" opacity="0.85" />
      <circle cx="37" cy="8.2" r="0.9" fill="currentColor" opacity="0.55" />
      <rect x="25.5" y="11.5" width="12" height="4.5" rx="0.8" fill="currentColor" opacity="0.22" />
      <rect x="25.5" y="17" width="9" height="2" rx="0.6" fill="currentColor" opacity="0.3" />
      <rect x="25.5" y="19.5" width="11" height="1.5" rx="0.5" fill="currentColor" opacity="0.2" />
    </svg>
  );
}
